import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ManageCampaignService } from 'src/app/private/services/manage-campaign.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { from } from 'rxjs';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { emailSubjectValidator } from 'src/app/private/validators/email-subject.validator';
import { CampaignService } from 'src/app/private/services/campaign.service';
import { WhatsappVoiceCampaignService } from 'src/app/private/services/whatsapp-voice-campaign.service';
import { CampaignSegmentService } from 'src/app/private/services/campaign-segment.service';
import { appendCenterScopeToPayload } from 'src/app/utils/tenant-scope.util';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

export const TIMEZONES = [
  { label: 'UTC (UTC+0)', value: 'UTC' },
  { label: 'IST – India Standard Time (UTC+5:30)', value: 'Asia/Kolkata' },
  { label: 'GST – Gulf Standard Time (UTC+4)', value: 'Asia/Dubai' },
  { label: 'PKT – Pakistan Standard Time (UTC+5)', value: 'Asia/Karachi' },
  { label: 'BST – Bangladesh Standard Time (UTC+6)', value: 'Asia/Dhaka' },
  { label: 'ICT – Indochina Time (UTC+7)', value: 'Asia/Bangkok' },
  { label: 'CST – China Standard Time (UTC+8)', value: 'Asia/Shanghai' },
  { label: 'JST – Japan Standard Time (UTC+9)', value: 'Asia/Tokyo' },
  { label: 'AEST – Australian Eastern Time (UTC+10)', value: 'Australia/Sydney' },
  { label: 'NZST – New Zealand Standard Time (UTC+12)', value: 'Pacific/Auckland' },
  { label: 'MSK – Moscow Standard Time (UTC+3)', value: 'Europe/Moscow' },
  { label: 'GMT – Greenwich Mean Time (UTC+0)', value: 'Europe/London' },
  { label: 'CET – Central European Time (UTC+1)', value: 'Europe/Paris' },
  { label: 'EET – Eastern European Time (UTC+2)', value: 'Europe/Bucharest' },
  { label: 'BRT – Brasília Time (UTC-3)', value: 'America/Sao_Paulo' },
  { label: 'EST – Eastern Time (UTC-5)', value: 'America/New_York' },
  { label: 'CST – Central Time (UTC-6)', value: 'America/Chicago' },
  { label: 'MST – Mountain Time (UTC-7)', value: 'America/Denver' },
  { label: 'PST – Pacific Time (UTC-8)', value: 'America/Los_Angeles' },
  { label: 'AKST – Alaska Time (UTC-9)', value: 'America/Anchorage' },
  { label: 'HST – Hawaii Time (UTC-10)', value: 'Pacific/Honolulu' },
];

@Component({
  selector: 'app-create-broadcast-campaign',
  providers: [DatePipe] ,
  templateUrl: './create-broadcast-campaign.component.html',
  styleUrls: ['./create-broadcast-campaign.component.scss']
})
export class CreateBroadcastCampaignComponent {

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();

  @Input() type: string = 'Create';
  btnLoading = false;

  campaignForm: FormGroup;
  broadcastType: string = '';

  @Input() emailTemplates: any[] = [];
  @Input() whatsappTemplates: any[] = [];
  @Input() contactGroups: any[] = [];
  @Input() organisationEmails: any[] = [];
  @Input() aiFlows: any[] = [];
  @Input() campaignData: any;
  @Input() active: string = '';
  isSubmitted: boolean = false;
  isSchedule = false;
  isAdmin: boolean = false;
  totalContactsInGroup: number | null = null;
  isLoadingContactsCount: boolean = false;
  skipCampaignCount: number | null = null;
  isLoadingSkipCampaignCount: boolean = false;

  get noEligibleRecipients(): boolean {
    if (this.active !== 'whatsapp' && this.active !== 'email') {
      return false;
    }
    if (this.totalContactsInGroup === null || this.skipCampaignCount === null) {
      return false;
    }
    return this.skipCampaignCount >= this.totalContactsInGroup;
  }

  /** CC recipients (stored as JSONB array in cc_email) */
  ccEmails: string[] = [];
  ccInput = '';
  ccEmailError = '';
  campaignSegments: any[] = [];
  newSegmentName = '';
  segmentError = '';
  segmentSaving = false;
  overviewTemplateLoading = false;
  overviewTemplateName = '';
  overviewEmailHtml: SafeHtml | null = null;
  overviewEmailAttachments: any[] = [];
  overviewWhatsappTemplate: any = null;
  overviewWaHtml: SafeHtml | null = null;
  overviewWaHeader = '';
  overviewWaFooter = '';
  overviewWaTime = '';
  private previousSegment = '';
  @ViewChild('createSegmentModal') createSegmentModal!: TemplateRef<any>;

  timezones = TIMEZONES;
  /** UTC preview shown below the timezone dropdown */
  utcPreview: string = '';

  // Email Reputation
  reputationData: any = null;
  isReputationLoading: boolean = false;
  reputationError: string | null = null;


  constructor(private fb: FormBuilder, private http: HttpClient,

    private api: ManageCampaignService,
    private localStorage: LocalStorageService,
    private tracker: TrackingService,
    private toast: ToastrService,
    private datePipe: DatePipe,
    private contactGroupService: ContactGrouopService,
    private campaignService: CampaignService,
    private voiceCampaignService: WhatsappVoiceCampaignService,
    private campaignSegmentService: CampaignSegmentService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.campaignForm = this.fb.group({
      event_name: ['', Validators.required],
      from_email: [''],
      subject: [''],
      broadcast_type: ['', Validators.required],
      template_id: ['', Validators.required],
      contact_group_id: ['', Validators.required],
      status: ['Pending', Validators.required],
      is_schedule: [false],
      schedule_date: [''],
      schedule_time: [''],
      schedule_timezone: [Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'],
      ai_agent_flow_id: [''],
      call_delay_ms: [1000, [Validators.required, Validators.min(0), Validators.max(10000)]],
      batch_count: [1, [Validators.required, Validators.min(1)]],
      batch_delay_ms: [5000, [Validators.required, Validators.min(0), Validators.max(120000)]],
      segment: ['']
    });

    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }


  ngOnInit(): void {
    this.loadCampaignSegments();
    const defaultTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    this.ensureTimezoneOption(defaultTz);

    // Set initial broadcast type
  this.campaignForm
    .get('broadcast_type')
    ?.setValue(this.active);

  // React to broadcast type change
  this.campaignForm
    .get('broadcast_type')
    ?.valueChanges
    .subscribe(type => {
      if (type === 'email') {
        this.applyEmailValidators();
      } else if (type === 'call') {
        this.applyCallValidators();
      } else {
        this.clearEmailValidators();
        this.campaignForm.get('template_id')?.setValidators([Validators.required]);
        this.campaignForm.get('template_id')?.updateValueAndValidity();
      }
    });

  // Apply immediately if email or call
  if (this.active === 'email') {
    this.applyEmailValidators();
  } else if (this.active === 'call') {
    this.applyCallValidators();
  } else {
    this.campaignForm.get('template_id')?.setValidators([Validators.required]);
    this.campaignForm.get('template_id')?.updateValueAndValidity();
  }
    if (this.active === 'email' || this.campaignData?.campaign_type === 'email') {
      const fromEmail = this.resolveFromEmail();
      if (fromEmail) {
        this.campaignForm.get('from_email')?.setValue(fromEmail);
      }
  }
  

    if (this.type === 'Edit' || this.type === 'View') {
      const savedTimezone = this.campaignData.schedule_timezone
        || Intl.DateTimeFormat().resolvedOptions().timeZone
        || 'UTC';
      this.ensureTimezoneOption(savedTimezone);

      const isScheduled = !!this.campaignData.is_schedule;
      const { date: scheduleDateStr, time: scheduleTimeStr } = isScheduled
        ? this.parseScheduleForEdit(
            this.campaignData.schedule_date,
            this.campaignData.schedule_time,
            savedTimezone
          )
        : { date: '', time: '' };

      this.campaignForm.patchValue({
        event_name: this.campaignData.campaign_name || this.campaignData.event_name,
        broadcast_type: this.campaignData.campaign_type || 'call',
        template_id: this.campaignData.template_id,
        contact_group_id: this.campaignData.contact_group_id != null && this.campaignData.contact_group_id !== ''
          ? String(this.campaignData.contact_group_id)
          : '',
        status: this.campaignData.status,
        is_schedule: isScheduled,
        schedule_date: scheduleDateStr,
        schedule_time: scheduleTimeStr,
        schedule_timezone: savedTimezone,
        ai_agent_flow_id: this.campaignData.ai_agent_flow_id || '',
        call_delay_ms: this.campaignData.call_delay_ms ?? 1000,
        batch_count: this.campaignData.batch_count ?? 1,
        batch_delay_ms: this.campaignData.batch_delay_ms ?? 5000,
        segment: this.campaignData.segment || '',
      });
      this.previousSegment = this.campaignData.segment || '';
      
      this.broadcastType = this.campaignData.campaign_type || 'call';
      this.isSchedule = isScheduled;

      this.active = this.campaignData.campaign_type || 'call';
      if(this.broadcastType == "email") {
         this.campaignForm.patchValue({
        from_email: this.campaignData.from_email,
        subject: this.campaignData.subject,
      });
      this.ccEmails = this.parseCcEmailsFromValue(this.campaignData.cc_email);
      this.ccInput = '';
      this.ccEmailError = '';
      }

      if (this.isSchedule) {
        this.updateUtcPreview();
      }
      this.ensureSelectedContactGroup();
      if (this.type === 'View') {
        this.campaignForm.disable();
        this.loadOverviewTemplate();
      }
    }

    // Update UTC preview whenever date, time, or timezone changes
    ['schedule_date', 'schedule_time', 'schedule_timezone'].forEach(field => {
      this.campaignForm.get(field)?.valueChanges.subscribe(() => this.updateUtcPreview());
    });

    // Subscribe to contact group changes
    this.campaignForm.get('contact_group_id')?.valueChanges.subscribe(groupId => {
      if (groupId) {
        this.getContactCount(groupId);
      } else {
        this.totalContactsInGroup = null;
      }
      this.refreshCampaignSkipCount();
    });

    // Auto-fetch reputation when from_email changes (email campaigns only)
    this.campaignForm.get('from_email')?.valueChanges.subscribe((email: string) => {
      if (this.active === 'email' && email) {
        this.fetchEmailReputation(email);
      } else {
        this.reputationData = null;
        this.reputationError = null;
      }
      this.refreshCampaignSkipCount();
    });

    // Also fetch on init if from_email is already set (default / edit mode)
    setTimeout(() => {
      if (this.active === 'email') {
        const currentEmail = this.campaignForm.get('from_email')?.value;
        if (currentEmail) {
          this.fetchEmailReputation(currentEmail);
        }
      }
    }, 0);

    if (this.campaignForm.get('contact_group_id')?.value) {
      this.getContactCount(this.campaignForm.get('contact_group_id')?.value);
    }
    this.refreshCampaignSkipCount();

    // filter based on template_name empty in whatsappTemplates 
    this.whatsappTemplates = this.whatsappTemplates.filter(template => (template.template_name !== '' && template.template_name !== null));

  }

  getOrgEmail (){
  if (!this.organisationEmails?.length) {
    return [];
  }

  // 🔹 Get only campaign emails
  const campaignEmails = this.organisationEmails.filter(
    (item: any) => item?.type === 'campaign'
  );

  
  return campaignEmails;

  }

  ngAfterViewInit() {
  // if (this.active === 'whatsapp') {
  //   this.campaignForm.get('broadcast_type')?.setValue('whatsapp');
  //   this.clearEmailValidators();
  // }

  // if (this.active === 'email') {
  //   this.campaignForm.get('broadcast_type')?.setValue('email');
  //   this.broadcastType = 'email';
  //   this.applyEmailValidators();
  // }
}
  onBroadcastTypeChange(event: any) {
     
  }

private applyEmailValidators() {
  const fromEmailCtrl:any = this.campaignForm.get('from_email');
  const subjectCtrl = this.campaignForm.get('subject');

  fromEmailCtrl?.setValidators([Validators.required]);
  subjectCtrl?.setValidators([Validators.required, emailSubjectValidator, Validators.minLength(5), Validators.maxLength(100)]);

  fromEmailCtrl?.updateValueAndValidity();
  subjectCtrl?.updateValueAndValidity();

  // Auto-fill if empty
  if (!fromEmailCtrl?.value) {
    const fromEmail = this.resolveFromEmail();
    if (fromEmail) {
      fromEmailCtrl.setValue(fromEmail);
    }
  }
}

private clearEmailValidators() {
  const fromEmailCtrl = this.campaignForm.get('from_email');
  const subjectCtrl = this.campaignForm.get('subject');

  fromEmailCtrl?.clearValidators();
  subjectCtrl?.clearValidators();

  fromEmailCtrl?.updateValueAndValidity();
  subjectCtrl?.updateValueAndValidity();
}

private applyCallValidators() {
  this.clearEmailValidators();
  const templateIdCtrl = this.campaignForm.get('template_id');
  templateIdCtrl?.clearValidators();
  templateIdCtrl?.updateValueAndValidity();
}
 private resolveFromEmail(): string | null {
  if (!this.organisationEmails?.length) {
    return null;
  }

  // 🔹 Get only campaign emails
  const campaignEmails = this.organisationEmails.filter(
    (item: any) => item?.type === 'campaign'
  );

  if (!campaignEmails.length) {
    return null;
  }

  // 🔹 Return first campaign email (supports string/object safety)
  return campaignEmails[0]?.email || campaignEmails[0];
}

  parseCcEmailsFromValue(value: string | string[] | null | undefined): string[] {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.map(e => String(e).trim()).filter(Boolean);
    }
    const str = String(value).trim();
    if (!str) return [];
    if (str.startsWith('[')) {
      try {
        const parsed = JSON.parse(str);
        if (Array.isArray(parsed)) {
          return parsed.map(e => String(e).trim()).filter(Boolean);
        }
      } catch (_) {
        // fall through
      }
    }
    return str.split(/[,;]/).map(e => e.trim()).filter(Boolean);
  }

  isValidCcEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  addCcEmail(): void {
    this.ccEmailError = '';
    const raw = (this.ccInput || '').trim();
    if (!raw) return;

    const parts = raw.split(/[,;]/).map(e => e.trim()).filter(Boolean);
    for (const email of parts) {
      if (!this.isValidCcEmail(email)) {
        this.ccEmailError = `Invalid email: ${email}`;
        return;
      }
      const lower = email.toLowerCase();
      if (!this.ccEmails.some(e => e.toLowerCase() === lower)) {
        this.ccEmails.push(email);
      }
    }
    this.ccInput = '';
  }

  removeCcEmail(email: string): void {
    this.ccEmails = this.ccEmails.filter(e => e !== email);
    this.ccEmailError = '';
  }

  flushPendingCcInput(): void {
    if ((this.ccInput || '').trim()) {
      this.addCcEmail();
    }
  }

  serializeCcEmails(): string[] | null {
    return this.ccEmails.length ? [...this.ccEmails] : null;
  }

  loadCampaignSegments(): void {
    this.campaignSegmentService.getAllCampaignSegmentTypes({
      client_id: this.localStorage.getClientId()
    }).subscribe({
      next: (res: any) => {
        const rows = Array.isArray(res?.data) ? [...res.data] : [];
        const current = String(this.campaignData?.segment || this.campaignForm.get('segment')?.value || '').trim();
        const match = current
          ? rows.find((segment: any) => String(segment.segment_name).toLowerCase() === current.toLowerCase())
          : null;
        if (current && current !== '__new__' && !match) {
          rows.unshift({ segment_name: current });
        }
        this.campaignSegments = rows;
        if ((this.type === 'Edit' || this.type === 'View') && current && current !== '__new__') {
          const value = match?.segment_name || current;
          setTimeout(() => {
            this.campaignForm.get('segment')?.setValue(value);
            this.previousSegment = value;
          });
        }
      },
      error: () => {
        this.campaignSegments = [];
      }
    });
  }

  get overviewContactGroup(): string {
    return this.contactGroupName(this.campaignData);
  }

  private contactGroupName(campaign: any): string {
    const saved = campaign?.contact_group?.name || campaign?.contact_group_name;
    if (saved) return saved;
    const match = (this.contactGroups || []).find((group: any) =>
      String(group.id) === String(campaign?.contact_group_id)
    );
    return match?.name || '—';
  }

  private ensureSelectedContactGroup(): void {
    const id = this.campaignData?.contact_group_id;
    if (id == null || id === '') return;
    const groups = this.contactGroups || [];
    const match = groups.find((group: any) => String(group.id) === String(id));
    if (!match) {
      this.contactGroups = [{
        id: String(id),
        name: this.campaignData?.contact_group?.name || this.campaignData?.contact_group_name || 'Contact group'
      }, ...groups];
    }
    this.campaignForm.get('contact_group_id')?.setValue(String(id));
  }

  get overviewFlowName(): string {
    const id = this.campaignData?.ai_agent_flow_id;
    if (!id) return '—';
    const flow = (this.aiFlows || []).find((item: any) => String(item.id) === String(id));
    return flow ? `${flow.flow_name} (${flow.persona_name})` : String(id);
  }

  get overviewSchedule(): string {
    if (!this.campaignData?.is_schedule) return 'Not scheduled';
    const date = this.campaignData.schedule_date
      ? new Date(this.campaignData.schedule_date).toLocaleString()
      : '';
    const time = this.campaignData.schedule_time || '';
    const zone = this.campaignData.schedule_timezone || '';
    return [date || time, zone].filter(Boolean).join(' · ') || 'Scheduled';
  }

  private buildWhatsappPhonePreview(template: any): void {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    this.overviewWaTime = `${hours % 12 || 12}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;

    let header = '';
    let footer = '';
    let body = template?.content || template?.data || '';
    try {
      if (template?.containerMeta) {
        const meta = typeof template.containerMeta === 'string'
          ? JSON.parse(template.containerMeta)
          : template.containerMeta;
        header = meta?.header || '';
        footer = meta?.footer || '';
        body = meta?.sampleText || meta?.data || body;
      }
    } catch {
      body = template?.content || template?.data || '';
    }

    const text = String(body || '').replace(/\[(.*?)\]/g, '$1');
    const html = text
      .replace(/\n/g, '<br>')
      .replace(/\*(.*?)\*/g, '<b>$1</b>');
    this.overviewWaHeader = header;
    this.overviewWaFooter = footer;
    this.overviewWaHtml = html ? this.sanitizer.bypassSecurityTrustHtml(html) : null;
  }

  private loadOverviewTemplate(): void {
    const templateId = this.campaignData?.template_id;
    if (!templateId || this.active === 'call') return;

    this.overviewTemplateLoading = true;
    const payload = {
      client_id: this.localStorage.getClientId(),
      template_id: templateId
    };

    if (this.active === 'email') {
      const match = (this.emailTemplates || []).find((template: any) =>
        String(template.template_id) === String(templateId)
      );
      this.overviewTemplateName = match?.template_name || '';
      this.api.getEmailTemplateById(payload).subscribe({
        next: (res: any) => {
          this.overviewTemplateName = res?.template_name || this.overviewTemplateName || 'Email template';
          this.overviewEmailHtml = res?.template_body
            ? this.sanitizer.bypassSecurityTrustHtml(res.template_body)
            : null;
          this.overviewEmailAttachments = Array.isArray(res?.attachments) ? res.attachments : [];
          this.overviewTemplateLoading = false;
        },
        error: () => {
          this.overviewTemplateLoading = false;
        }
      });
      return;
    }

    const match = (this.whatsappTemplates || []).find((template: any) =>
      String(template.meta_template_id) === String(templateId) || String(template.template_id) === String(templateId)
    );
    this.overviewTemplateName = match?.template_name || '';
    this.api.getTemplateById(payload).subscribe({
      next: (res: any) => {
        const template = res?.containerMeta || res?.content || res?.data ? (res.containerMeta || res.content ? res : (res.data || res)) : res;
        this.overviewWhatsappTemplate = template;
        this.overviewTemplateName = template?.template_name || res?.template_name || this.overviewTemplateName || 'WhatsApp template';
        this.buildWhatsappPhonePreview(template);
        this.overviewTemplateLoading = false;
      },
      error: () => {
        this.overviewTemplateLoading = false;
      }
    });
  }

  private resolvedSegmentValue(): string | null {
    const selected = String(this.campaignForm.get('segment')?.value || '').trim();
    if (!selected || selected === '__new__') return null;
    return selected;
  }

  onSegmentChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    if (value !== '__new__') {
      this.previousSegment = value;
      return;
    }
    this.campaignForm.get('segment')?.setValue(this.previousSegment || '');
    this.newSegmentName = '';
    this.segmentError = '';
    this.modalService.open(this.createSegmentModal, {
      centered: true,
      backdrop: 'static',
      windowClass: 'campaign-segment-modal'
    });
  }

  saveNewSegment(modal: any): void {
    const name = (this.newSegmentName || '').trim();
    if (!name) {
      this.segmentError = 'Enter a segment name';
      return;
    }
    if (name.length > 50) {
      this.segmentError = 'Segment name can be up to 50 characters';
      return;
    }
    this.segmentError = '';
    this.segmentSaving = true;
    this.campaignSegmentService.createCampaignSegmentType({
      client_id: this.localStorage.getClientId(),
      segment_name: name
    }).subscribe({
      next: (res: any) => {
        const saved = res?.data?.segment_name || name;
        if (!this.campaignSegments.some((segment: any) => String(segment.segment_name).toLowerCase() === String(saved).toLowerCase())) {
          this.campaignSegments = [...this.campaignSegments, res?.data || { segment_name: saved }];
        }
        this.campaignForm.get('segment')?.setValue(saved);
        this.previousSegment = saved;
        this.newSegmentName = '';
        this.segmentSaving = false;
        this.toast.success(res?.already_exists ? 'Segment already exists and is selected' : 'Segment created');
        modal.close();
      },
      error: () => {
        this.segmentSaving = false;
        this.segmentError = 'Could not create segment';
      }
    });
  }

formatToUTC(date: Date, time?: string): string {
  const d = new Date(date);

  if (time) {
    const [h, m] = time.split(':').map(Number);
    d.setHours(h, m, 0, 0);
  } else {
    d.setHours(0, 0, 0, 0);
  }

  return (
    d.getUTCFullYear() + '-' +
    String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
    String(d.getUTCDate()).padStart(2, '0') + ' ' +
    String(d.getUTCHours()).padStart(2, '0') + ':' +
    String(d.getUTCMinutes()).padStart(2, '0') + ':' +
    String(d.getUTCSeconds()).padStart(2, '0') +
    '+00'
  );
}

/**
 * Converts a date+time in a given IANA timezone to a UTC datetime string.
 * Uses native Intl API — no external dependencies required.
 * Returns format: "YYYY-MM-DD HH:mm:ss+00"
 */
convertTZtoUTC(dateStr: string, timeStr: string, timezone: string): string {
  if (!dateStr || !timeStr) return '';

  // Normalise date string to YYYY-MM-DD
  const rawDate = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr.substring(0, 10);
  const [year, month, day] = rawDate.split('-').map(Number);
  const [hour, minute] = timeStr.split(':').map(Number);

  // Step 1: Create a UTC reference treating the given datetime as if it were UTC
  const utcRef = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));

  // Step 2: Format utcRef in the target timezone to get the "displayed" local time
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  }).formatToParts(utcRef);

  const p: Record<string, string> = {};
  parts.forEach(x => { p[x.type] = x.value; });

  // tzDisplayMs = what the timezone shows for utcRef, re-parsed as a UTC number
  const tzDisplayMs = Date.UTC(
    parseInt(p['year']), parseInt(p['month']) - 1, parseInt(p['day']),
    parseInt(p['hour'] === '24' ? '0' : p['hour']), parseInt(p['minute']), parseInt(p['second'] || '0')
  );

  // timezone offset (ms) = tzDisplayMs - utcRef.getTime()
  // true UTC for given local time  = localMs - offset
  const localMs = Date.UTC(year, month - 1, day, hour, minute, 0);
  const offset = tzDisplayMs - utcRef.getTime();
  const trueUTC = new Date(localMs - offset);

  return (
    trueUTC.getUTCFullYear() + '-' +
    String(trueUTC.getUTCMonth() + 1).padStart(2, '0') + '-' +
    String(trueUTC.getUTCDate()).padStart(2, '0') + ' ' +
    String(trueUTC.getUTCHours()).padStart(2, '0') + ':' +
    String(trueUTC.getUTCMinutes()).padStart(2, '0') + ':' +
    String(trueUTC.getUTCSeconds()).padStart(2, '0') +
    '+00'
  );
}

/** Ensure saved timezone appears in the dropdown (e.g. custom IANA ids). */
ensureTimezoneOption(tz: string): void {
  if (!tz || this.timezones.some(t => t.value === tz)) return;
  this.timezones = [...this.timezones, { label: tz, value: tz }];
}

/** Normalise DB schedule_date for HTML date input (YYYY-MM-DD). */
formatScheduleDateForInput(value: string | Date | null | undefined): string {
  if (!value) return '';
  if (value instanceof Date) {
    return value.toISOString().split('T')[0];
  }
  const str = String(value);
  if (str.includes('T')) return str.split('T')[0];
  if (str.includes(' ')) return str.substring(0, 10);
  return str.substring(0, 10);
}

/**
 * Build date/time strings for HTML date + time inputs when editing a scheduled campaign.
 * schedule_date is stored as UTC; schedule_time is the local time in schedule_timezone.
 */
parseScheduleForEdit(
  scheduleDate: string | Date | null | undefined,
  scheduleTime: string | null | undefined,
  timezone: string
): { date: string; time: string } {
  const timeHHmm = (scheduleTime || '').trim().substring(0, 5);

  if (!scheduleDate) {
    return { date: '', time: timeHHmm };
  }

  const str = String(scheduleDate);
  let utcDate: Date | null = null;

  if (scheduleDate instanceof Date) {
    utcDate = scheduleDate;
  } else if (str.includes('T') || str.includes(' ')) {
    const normalized = str.includes(' ')
      ? str.replace(' ', 'T').replace(/\+00:00$/, 'Z').replace(/\+00$/, 'Z')
      : str;
    const d = new Date(normalized);
    if (!isNaN(d.getTime())) utcDate = d;
  }

  // Full UTC datetime → local date in saved timezone; time from schedule_time when set
  if (utcDate && timezone) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(utcDate);

    const p: Record<string, string> = {};
    parts.forEach(x => {
      if (x.type !== 'literal') p[x.type] = x.value;
    });
    const hour = p['hour'] === '24' ? '00' : p['hour'];
    return {
      date: `${p['year']}-${p['month']}-${p['day']}`,
      time: timeHHmm || `${hour}:${p['minute']}`
    };
  }

  return {
    date: this.formatScheduleDateForInput(scheduleDate),
    time: timeHHmm
  };
}

/** Recomputes the UTC preview string for display under the timezone dropdown. */
updateUtcPreview(): void {
  const dateVal = this.campaignForm.get('schedule_date')?.value;
  const timeVal = this.campaignForm.get('schedule_time')?.value;
  const tzVal   = this.campaignForm.get('schedule_timezone')?.value;

  if (!dateVal || !timeVal || !tzVal) {
    this.utcPreview = '';
    return;
  }

  const rawDate = (dateVal instanceof Date)
    ? dateVal.toISOString().split('T')[0]
    : String(dateVal).includes('T') ? String(dateVal).split('T')[0] : String(dateVal).substring(0, 10);

  const utcStr = this.convertTZtoUTC(rawDate, timeVal, tzVal);
  if (utcStr) {
    // Display as "DD MMM YYYY HH:mm UTC"
    const utcDate = new Date(utcStr.replace('+00', 'Z').replace(' ', 'T'));
    const opts: Intl.DateTimeFormatOptions = {
      timeZone: 'UTC', day: '2-digit', month: 'short',
      year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false
    };
    this.utcPreview = new Intl.DateTimeFormat('en-GB', opts).format(utcDate) + ' UTC';
  } else {
    this.utcPreview = '';
  }
}
  onSubmit() {
    if (this.type === 'View') {
      return;
    }
    this.isSubmitted = true;
    if (this.noEligibleRecipients) {
      this.toast.error(
        'No contacts will receive this campaign. Every contact in this group will be skipped today.',
        'Cannot save'
      );
      return;
    }
    this.flushPendingCcInput();
    if (this.ccEmailError) {
      return;
    }
    let formattedTime: any = null;
    let formattedDate: any = null;
    let selectedTimezone: string = 'UTC';
    if (this.campaignForm.valid) {

      const isCall = this.campaignForm.get('broadcast_type')?.value === 'call';
      const status = this.campaignForm.get('status')?.value;

      if (!isCall && this.isSchedule) {
        const scheduleDate = this.campaignForm.get('schedule_date')?.value;
        const scheduleTime = this.campaignForm.get('schedule_time')?.value;
        selectedTimezone = this.campaignForm.get('schedule_timezone')?.value || 'UTC';

        if (scheduleTime) {
          const [hours, minutes] = scheduleTime.split(':');
          const timeAsDate = new Date();
          timeAsDate.setHours(+hours, +minutes, 0, 0);
          formattedTime = this.datePipe.transform(timeAsDate, 'HH:mm');
        }

        // Normalise date to YYYY-MM-DD string
        const rawDate = (scheduleDate instanceof Date)
          ? scheduleDate.toISOString().split('T')[0]
          : String(scheduleDate).includes('T')
            ? String(scheduleDate).split('T')[0]
            : String(scheduleDate).substring(0, 10);

        // Convert the user-entered local time (in selected timezone) to UTC for storage
        formattedDate = this.convertTZtoUTC(rawDate, formattedTime, selectedTimezone);
      }

      let payload: any;
      if (isCall) {
        payload = appendCenterScopeToPayload({
          client_id: this.localStorage.getClientId(),
          campaign_name: this.campaignForm.get('event_name')?.value,
          contact_group_id: Number(this.campaignForm.get('contact_group_id')?.value),
          ai_agent_flow_id: this.campaignForm.get('ai_agent_flow_id')?.value || null,
          call_delay_ms: Number(this.campaignForm.get('call_delay_ms')?.value ?? 1000),
          batch_count: Number(this.campaignForm.get('batch_count')?.value ?? 1),
          batch_delay_ms: Number(this.campaignForm.get('batch_delay_ms')?.value ?? 5000),
          created_by: this.localStorage.getUserId(),
          status: status
        }, this.localStorage);
      } else {
        payload = {
          campaign_name: this.campaignForm.get('event_name')?.value,
          campaign_type: this.campaignForm.get('broadcast_type')?.value,
          template_id: this.campaignForm.get('template_id')?.value,
          subject: this.campaignForm.get('subject')?.value,
          client_id: this.localStorage.getClientId(),
          contact_group_id: this.campaignForm.get('contact_group_id')?.value,
          is_schedule: this.isSchedule,
          schedule_date: formattedDate,
          schedule_time: formattedTime,
          schedule_timezone: this.isSchedule ? selectedTimezone : null,
          status: status,
          segment: this.resolvedSegmentValue()
        };

        if(this.campaignForm.get('broadcast_type')?.value=='email') {
          console.log("from_email",this.campaignForm.get('from_email')?.value)
          payload.from_email = this.campaignForm.get('from_email')?.value;
          payload.cc_email = this.serializeCcEmails();
        }
      }

      console.log('Payload before user_id check:', payload);

      if (!this.isAdmin && !isCall) {
        payload['user_id'] = this.localStorage.getUserId();
      }

      this.btnLoading = true;
      try {
        if (isCall) {
          const obs = this.type === 'Create'
            ? this.voiceCampaignService.create(payload)
            : this.voiceCampaignService.update({ ...payload, id: this.campaignData.id });

          obs.subscribe({
            next: (res: any) => {
              const action = this.type === 'Create' ? 'Create' : 'Update';
              const desc = `Voice campaign ${action.toLowerCase()}d with name: ${payload.campaign_name}`;
              this.tracker.track(action, "Voice Campaign", desc);
              if (this.type === 'Edit') {
                this.toast.success("Campaign updated successfully!", "Success");
              }
              this.formSubmit.emit();
              this.btnLoading = false;
            },
            error: (error: any) => {
              console.error('Error saving voice campaign:', error);
              const action = this.type === 'Create' ? 'create' : 'update';
              this.toast.error(`Failed to ${action} voice campaign. Please try again.`, "Error");
              this.btnLoading = false;
            }
          });
        } else {
          if (this.type === 'Create') {
            this.api.createCampaign(payload).subscribe({
              next: (res: any) => {
                const desc = `Broadcast campaign created with name: ${payload.campaign_name}, type: ${payload.campaign_type}`;
                this.tracker.track("Create", "Broadcast Campaign", desc);
                this.formSubmit.emit();
                this.btnLoading = false; // stop loader on success
              },
              error: (error: any) => {
                console.error('Error creating campaign:', error);
                this.toast.error("Failed to create broadcast campaign. Please try again.", "Error");
                this.btnLoading = false; // stop loader on failure
              }
            });

          } else {
            const payload2 = {
              id: this.campaignData.id,
              ...payload
            }
            this.api.updateCampaign(payload2).subscribe({
              next: (res: any) => {
                const desc = `Broadcast campaign updated with ID: ${payload2.id}, name: ${payload2.campaign_name}, and type: ${payload2.campaign_type}`;
                this.tracker.track("Update", "Broadcast Campaign", desc);
                console.log('Campaign updated successfully:', res);
                this.toast.success("Campaign updated successfully!", "Success");
                this.formSubmit.emit();
                this.btnLoading = false; // stop loader on success
              },
              error: (error: any) => {
                console.error('Error updating campaign:', error);
                this.toast.error("Failed to update campaign. Please try again.", "Error");
                this.btnLoading = false; // stop loader on failure
              }
            });
          }
        }
      } catch(e:any) {
        this.btnLoading = false;
      }
    }
  }

  onScheduleChange(event: any) {
    this.isSchedule = event.checked;
    if (this.isSchedule) {
      this.campaignForm.get('schedule_date')?.setValidators(Validators.required);
      this.campaignForm.get('schedule_time')?.setValidators(Validators.required);
    } else {
      this.campaignForm.get('schedule_date')?.clearValidators();
      this.campaignForm.get('schedule_time')?.clearValidators();
    }
    this.campaignForm.get('schedule_date')?.updateValueAndValidity();
    this.campaignForm.get('schedule_time')?.updateValueAndValidity();
  }

  closeModal() {
    this.close.emit();
  }

  openContactGroup(): void {
    const id = this.campaignData?.contact_group_id;
    if (!id) return;
    this.close.emit();
    this.router.navigate(['/main/contact-groups'], { queryParams: { groupId: id } });
  }

  getContactCount(groupId: number) {
    this.isLoadingContactsCount = true;
    const payload = {
      "where": {
        "client_id": this.localStorage.getClientId(),
        "contact_group_id": groupId
      },
      "filter": null,
      "page": 0,
      "limit": 10,
      "order": {
        "col": "\"contact_group_list\".\"updatedAt\"",
        "dir": "DESC"
      }
    };

    this.contactGroupService.getAllContactGroupList(payload).subscribe({
      next: (res: any) => {
        if (res && res.count !== undefined) {
          this.totalContactsInGroup = res.count;
        } else {
          this.totalContactsInGroup = 0;
        }
        this.isLoadingContactsCount = false;
      },
      error: (err: any) => {
        console.error('Error fetching contact count:', err);
        this.totalContactsInGroup = null;
        this.isLoadingContactsCount = false;
      }
    });
  }

  fetchEmailReputation(emailId: string) {
    this.isReputationLoading = true;
    this.reputationData = null;
    this.reputationError = null;
    this.campaignService.getReputation({
      email_id: emailId,
      client_id: this.localStorage.getClientId()
    }).subscribe({
      next: (res: any) => {
        console.log("res",res)
        if(res.success == true) {
          this.reputationData = res.data;
        } else {
          this.reputationData = null;
        } 
        this.isReputationLoading = false;
      },
      error: (err: any) => {
        console.error('Error fetching email reputation:', err);
        this.reputationError = 'Unable to load email health data.';
        this.isReputationLoading = false;
      }
    });
  }

  refreshCampaignSkipCount(): void {
    if (this.active !== 'email' && this.active !== 'whatsapp') {
      this.skipCampaignCount = null;
      this.isLoadingSkipCampaignCount = false;
      return;
    }

    const senderEmail = String(this.campaignForm.get('from_email')?.value || '').trim();
    const contactGroupId = this.campaignForm.get('contact_group_id')?.value;

    if ((this.active === 'email' && !senderEmail) || !contactGroupId) {
      this.skipCampaignCount = null;
      this.isLoadingSkipCampaignCount = false;
      return;
    }

    this.isLoadingSkipCampaignCount = true;
    this.contactGroupService.getCampaignSkipCount({
      client_id: this.localStorage.getClientId(),
      contact_group_id: Number(contactGroupId),
      broadcast_type: this.active,
      sender_email: senderEmail,
    }).subscribe({
      next: (res: any) => {
        this.skipCampaignCount = Number(res?.count ?? 0);
        this.isLoadingSkipCampaignCount = false;
      },
      error: (err: any) => {
        console.error('Error fetching campaign skip count:', err);
        this.skipCampaignCount = null;
        this.isLoadingSkipCampaignCount = false;
      }
    });
  }

  getReputationScoreColor(score: number): string {
    if (score >= 80) return '#10b981';
    if (score >= 60) return '#f59e0b';
    return '#ef4444';
  }

  getReputationScoreLabel(score: number): string {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Fair';
    return 'Poor';
  }

  getReputationScoreBg(score: number): string {
    if (score >= 80) return 'rgba(16,185,129,0.1)';
    if (score >= 60) return 'rgba(245,158,11,0.1)';
    return 'rgba(239,68,68,0.1)';
  }

  getRiskColor(riskLevel: string): string {
    const level = (riskLevel || '').toLowerCase();
    if (level === 'low') return '#10b981';
    if (level === 'medium') return '#f59e0b';
    return '#ef4444';
  }

  getRiskBg(riskLevel: string): string {
    const level = (riskLevel || '').toLowerCase();
    if (level === 'low') return 'rgba(16,185,129,0.12)';
    if (level === 'medium') return 'rgba(245,158,11,0.12)';
    return 'rgba(239,68,68,0.12)';
  }

  getWarmupPercent(warmup: any): number {
    if (!warmup || !warmup.daily_limit) return 0;
    return Math.round((warmup.sent_today / warmup.daily_limit) * 100);
  }

  get batchPreview(): string {
    const total = this.totalContactsInGroup || 0;
    const batches = Number(this.campaignForm.get('batch_count')?.value) || 1;
    const perBatch = Math.ceil(total / batches);
    const batchDelayS = (Number(this.campaignForm.get('batch_delay_ms')?.value) || 0) / 1000;
    const callDelayS  = (Number(this.campaignForm.get('call_delay_ms')?.value)  || 0) / 1000;
    return total > 0
      ? `${total} contacts ÷ ${batches} batches = ~${perBatch} per batch | Call delay: ${callDelayS}s | Batch delay: ${batchDelayS}s`
      : `${batches} batches | Call delay: ${callDelayS}s | Batch delay: ${batchDelayS}s`;
  }
}
